import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Itaobuy vs Alternative: Confronto Completo dei Migliori Agent 2026',
  url: `${siteUrl}/itaobuy-vs-alternative`,
  description: 'Itaobuy vs Sugargoo, Pandabuy, CSSBuy: quale scegliere? Confronto dettagliato su prezzi, servizio e qualità.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function AlternativePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ CONFRONTO</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Itaobuy vs Alternative: Confronto Completo dei Migliori Agent 2026
            </h1>
            <p className="text-background-50/70 text-sm md:text-base"><strong className="text-background-50">Itaobuy vs Sugargoo, Pandabuy, CSSBuy</strong>: quale scegliere? Confronto dettagliato su prezzi, servizio e qualità.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per esplorare il database itaobuy spreadsheet.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Itaobuy vs Sugargoo</h2>
              <p className="mb-4">Il confronto tra <strong className="text-foreground-950">itaobuy e Sugargoo</strong> vede itaobuy distinguersi per il database spreadsheet integrato, che offre un vantaggio significativo nella ricerca prodotti. Sugargoo ha un'interfaccia più tradizionale ma itaobuy compensa con l'organizzazione e la community attiva di utenti italiani.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Itaobuy vs Pandabuy</h2>
              <p className="mb-4"><strong className="text-foreground-950">Itaobuy vs Pandabuy</strong>: entrambi offrono un buon servizio, ma itaobuy spreadsheet si distingue per la completezza del database e la facilità di navigazione tra le categorie. Pandabuy ha una base utenti più ampia, ma itaobuy offre un'esperienza più curata per il mercato italiano.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Perché Scegliere Itaobuy</h2>
              <p className="mb-4">La forza di <strong className="text-foreground-950">itaobuy spreadsheet</strong> risiede nel database organizzato, nelle recensioni verificate e nel supporto della community italiana. Leggi anche la <Link to="/itaobuy-recensioni" className="text-primary-600 font-medium hover:underline">pagina delle recensioni</Link> per le opinioni degli utenti.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Prova Itaobuy</h3>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Itaobuy vs alternative</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}